import { render, staticRenderFns } from "./Retention.vue?vue&type=template&id=3954f079&"
import script from "./Retention.vue?vue&type=script&lang=js&"
export * from "./Retention.vue?vue&type=script&lang=js&"
import style0 from "./Retention.vue?vue&type=style&index=0&id=3954f079&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports